import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const VideoListSk = () => {
  return (
    <div className="card">
      <div className='card-header border-0 pt-5'>
        <div className='d-flex align-items-center gap-10'>
          <h3 className='card-title align-items-start flex-column'>
            <Skeleton width={100} height={24} />
          </h3>
        </div>
        <div className='card-toolbar'>
          <Skeleton height={40} width={100} />
        </div>
      </div>
      <div className='card-body py-10 d-flex flex-wrap justify-content-center'>
        {Array.from({ length: 8 }).map((_, index) => (
          <div key={index} className=' position-relative bg-white text-black' style={{ width: '220px', borderRadius: '9px', margin: '10px' }}>
            <div className=' position-relative'>
              <Skeleton height={160} width="100%" />
              <div className='icon-overlay position-absolute' style={{ left: '50%', top: '50%', transform: 'translate(-50%, -50%)' }}>
                <Skeleton circle height={50} width={50} />
              </div>
            </div>
            <div className='px-2' style={{ height: '90px' }}>
              <Skeleton height={20} width="100%" className="mb-2" />
              <Skeleton height={20} width="80%" className="mb-2" />
            </div>
          </div>
        ))}
      </div>
      <div className='d-flex align-items-center justify-content-end pb-5 pe-5'>
        <Skeleton height={40} width={100} />
      </div>
    </div>
  );
};

export default VideoListSk;
